import { graphql } from "@/api/graphql/types/gql";

export const enableAgentMutation = graphql(`
  mutation EnableAgent($request: AccountsMsEnableSupportUserRequest) {
    AccountsMsEnableSupportUser(request: $request)
  }
`);
